<template>
<div></div>
</template>

<script>
export default {
    props: {
        dictItems: null,
        categories: null,
        total: null,
        myOrder: null,
        user: null,
        fromStore: false,
    },
    data() {
        return {
            accessToken: false,
            fbclid: null,
            fbclid_time: null,
        }
    },
    methods: {
        SetupGoogleAnalytics(googleAnalyticsID)
        {
            if(!googleAnalyticsID) return;
            var newScript = document.createElement("script");
            newScript.type = "text/javascript";
            newScript.setAttribute("async", "true");
            newScript.setAttribute("src", "https://www.googletagmanager.com/gtag/js?id="+googleAnalyticsID);
            document.documentElement.firstChild.appendChild(newScript);

            window.dataLayer = window.dataLayer || [];
            function gtag(){dataLayer.push(arguments);}
            gtag('js', new Date());
            gtag('config', googleAnalyticsID);

            window.gtag = gtag;
        },
        SetupFacebookPixel(facebookPixelID, accessToken)
        {
            if(!facebookPixelID) return;
            this.accessToken = accessToken;

            let userData = {};

            this.$nextTick(() =>{
                if (this.fromStore && this.user) {
                    const { first_name, last_name } = this.SplitName(this.user.name || "");

                    if (this.user.email) userData.em = this.user.email;
                    if (this.user.phone) userData.ph = this.Util.NormalizePhone(this.user.phone);
                    if (first_name) userData.fn = first_name;
                    if (last_name) userData.ln = last_name;
                }

                var newScript = document.createElement("script");
                newScript.type = "text/javascript";
                newScript.text = `
                    !function(f,b,e,v,n,t,s)
                    {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
                    n.callMethod.apply(n,arguments):n.queue.push(arguments)};
                    if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
                    n.queue=[];t=b.createElement(e);t.async=!0;
                    t.src=v;s=b.getElementsByTagName(e)[0];
                    s.parentNode.insertBefore(t,s)}(window, document,'script',
                    'https://connect.facebook.net/en_US/fbevents.js');
                    fbq('init', ${facebookPixelID}, ${JSON.stringify(userData)});
                `;

                setTimeout(() => {
                    this.Trigger('page_view', {});
                }, 1000);

                document.documentElement.firstChild.appendChild(newScript);
            });
        },
        GtagItem(id, quantity)
        {
            var item = this.dictItems[id];
            var ret = {
                item_id: item.title,
                item_name: item.title,
                currency: 'CLP',
                item_list_id: item.section,
                item_list_name: item.section,
                price: item.price,
                quantity: quantity ? quantity : 1
            }

            var count = 1;
            if(item.categories)
            {
                for(var key in item.categories)
                {
                    if(this.categories[key])
                    {
                        ret[`item_category${count>1?count:''}`] = this.categories[key].title;
                        count++;
                        if(count > 5) break;
                    }
                }
            }
            return ret;
        },
        GtagItems(list)
        {
            var ret = [];
            list.forEach(item => {
                ret.push(this.GtagItem(item.id, item.quantity));
            });
            return ret;
        },
        FBPixelItem(id, quantity)
        {
            var item = this.dictItems[id];
            var ret = {
                content_ids: item.title,
                content_category: item.categories && item.categories.length ? this.categories[item.categories[0]].title : '',
                content_name: item.title,
                content_type: 'product',
                contents: [{id: item.title, quantity: quantity ? quantity : 1}],
                currency: 'CLP', 
                value: item.price * (item.quantity ? item.quantity : 1)
            }
            return ret;
        },
        //TODO: data agnostic from total, categories, myOrder, dictItems
        Trigger(event, data)
        {
            console.log(`> Trigger Analitics ${event}`);
            let id = Math.random().toString().replace('.', '');
            if(event == 'view_item')
            {
                this.TriggerGTAG('view_item', {
                    currency: 'CLP',
                    items: [this.GtagItem(data.id)],
                    value: data.price
                });
                this.TriggerFBPixel('ViewContent', this.FBPixelItem(data.id), id);
                this.TriggerCAPI({
                    event: 'ViewContent',
                    data: this.FBPixelItem(data.id),
                    event_id: id
                });
                return;
            }
            if(event == 'add_to_cart')
            {
                this.TriggerGTAG('add_to_cart', {
                    currency: 'CLP',
                    items: [this.GtagItem(data.item.id, data.quantity)],
                    value: data.quantity*data.total
                });
                this.TriggerFBPixel('AddToCart', this.FBPixelItem(data.item.id, data.quantity), id);
                this.TriggerCAPI({
                    event: 'AddToCart',
                    data: this.FBPixelItem(data.item.id, data.quantity),
                    event_id: id
                });
                return; 
            }
            if(event == 'remove_from_cart')
            {
                var item = this.GtagItem(parseInt(data.key), -data.quantity);
                this.TriggerGTAG('remove_from_cart', {
                    currency: 'CLP',
                    items: [item],
                    value: item.quantity*item.price
                });
                return;
            }
            if(event == 'view_item_list')
            {
                var items = this.GtagItems(data.items);
                this.TriggerGTAG('view_item_list', {
                    item_list_id: data.title,
                    item_list_name: data.title,
                    items: items
                });
                return;
            }
            if(event == 'search')
            {
                this.TriggerGTAG('search', {
                    search_term: data
                });
                this.TriggerFBPixel('Search', {
                    search_string: data
                }, id);
                this.TriggerCAPI({
                    event: 'Search',
                    data: {
                        search_string: data
                    },
                    event_id: id
                });
                return;
            }
            if(event == 'add_payment_info')
            {
                this.TriggerGTAG('add_payment_info', {
                    currency: 'CLP',
                    value: this.total.total,
                    payment_type: data,
                    items: this.GtagItems(Object.values(this.myOrder))
                });
                this.TriggerFBPixel('AddPaymentInfo', {
                    currency: 'CLP',
                    value: this.total.total,
                    content_ids: data
                }, id);
                this.TriggerCAPI({
                    event: 'AddPaymentInfo',
                    data: {
                        currency: 'CLP',
                        value: this.total.total,
                        content_ids: data
                    },
                    event_id: id
                });
                return;
            }
            if(event == 'begin_checkout')
            {
                this.TriggerGTAG('begin_checkout', {
                    currency: 'CLP',
                    value: this.total.total,
                    items: this.GtagItems(Object.values(data.orders))
                });
                this.TriggerFBPixel('InitiateCheckout', {
                    currency: 'CLP',
                    value: data.total.total
                }, data.id);
                this.TriggerCAPI({
                    event: 'InitiateCheckout',
                    event_id: data.id,
                    data: {
                        currency: 'CLP',
                        value: data.total.total
                    },
                });
                return;
            }
            if(event == 'purchase')
            {
                this.TriggerGTAG('purchase', {
                    currency: 'CLP',
                    transaction_id: data.id,
                    value: data.total.total,
                    items: this.GtagItems(Object.values(data.orders)),
                    shipping: data.total.delivery
                });
                this.TriggerFBPixel('Purchase', {
                    currency: 'CLP',
                    value: data.total.total
                }, data.id);
                this.TriggerCAPI({
                    event: 'Purchase',
                    event_id: data.id,
                    data: {
                        currency: 'CLP',
                        value: data.total.total
                    },
                });
                return;
            }
            if(event == 'select_promotion')
            {
                this.TriggerGTAG('event', 'select_promotion', {
                    promotion_name: data,
                });
                return;
            }
            if(event == 'view_cart')
            {
                this.TriggerGTAG('view_cart', {
                    currency: 'CLP',
                    value: this.total.total,
                    items: this.GtagItems(Object.values(this.myOrder))
                });
                /*
                //segun chatgpt no Lead no es un analogo a view_cart
                this.TriggerFBPixel('Lead', {
                    currency: 'CLP',
                    value: this.total.total
                }, id);
                this.TriggerCAPI({
                    event: 'Lead',
                    data: {
                        currency: 'CLP',
                        value: this.total.total
                    },
                    event_id: id
                });
                */
                return;
            }
            if(event == 'add_shipping_info')
            {
                this.TriggerGTAG('add_shipping_info', {
                    currency: 'CLP',
                    value: this.total.total,
                    items: this.GtagItems(Object.values(this.myOrder)),
                    shipping_tier: data == 'AUTO' ? 'Lo antes posible' : 'Programado'
                });
                this.TriggerFBPixel('FindLocation', {}, id);
                this.TriggerCAPI({
                    event: 'FindLocation',
                    data: {},
                    event_id: id
                });
                return;
            }

            if(event == 'page_view')
            {
                this.TriggerFBPixel('PageView', {}, id);
                this.TriggerCAPI({
                    event: 'PageView',
                    data: {},
                    event_id: id
                });
                return;
            }
        },
        TriggerGTAG(event, data)
        {
            if(window.gtag)
            {
                gtag('event', event, data);
            }
        },
        TriggerFBPixel(event, data, id)
        {
            if(window.fbq)
            {
                fbq('track', event, data, id ? {eventID: id} : null);
            }
        },
        SplitName(fullName) {
            if (!fullName) return { first_name: '', last_name: '' };
            const parts = fullName.trim().split(/\s+/);
            if (parts.length === 1) return { first_name: parts[0], last_name: '' };
            if (parts.length === 2) return { first_name: parts[0], last_name: parts[1] };
            const last_name = parts.slice(-2).join(' ');
            const first_name = parts.slice(0, -2).join(' ');
            return { first_name, last_name };
        },
        //Facebook conversion api
        TriggerCAPI(eventData)
        {
            if (!this.accessToken || !eventData) return;

            eventData.user_data = {};

            if(this.fbclid) {
                eventData.user_data.fbclid = this.fbclid;
                eventData.user_data.fbclid_time = this.fbclid_time;
            }

            if (!this.fromStore) return this.ApiMeta(eventData);

            if (!this.user || !this.user.name) return;

            const { first_name, last_name } = this.SplitName(this.user.name);

            if (this.user.email) eventData.user_data.em = this.user.email;
            if (this.user.phone) eventData.user_data.ph = this.user.phone;
            if (first_name) eventData.user_data.fn = first_name;
            if (last_name) eventData.user_data.ln = last_name;

            if (Object.keys(eventData.user_data).length === 0) return;
            
            this.ApiMeta(eventData);
        },
        ApiMeta(eventData){
            eventData.action_source = "website";
            eventData.event_source_url = window.location.origin + window.location.pathname;

            axios.post(`/trigger/event/meta`, eventData)
                .then(({ data }) => {})
                .catch(() => {});

            return;
        }
    }
}
</script>

<style>

</style>